"use client";
import {
  useGroup
} from "./36LIF33V.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./LMDWO4NN.js";
import {
  __objRest
} from "./3YLGPPWQ.js";

// src/form/form-group.tsx
var TagName = "div";
var useFormGroup = createHook(
  function useFormGroup2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = useGroup(props);
    return props;
  }
);
var FormGroup = forwardRef(function FormGroup2(props) {
  const htmlProps = useFormGroup(props);
  return createElement(TagName, htmlProps);
});

export {
  useFormGroup,
  FormGroup
};
